import axiosinstances from "../Helper/useAxios";

export async function getprofileserviicesresponse(data) {
  const [axiosInstance] = axiosinstances();
  const d =
    sessionStorage.getItem("token") &&
    JSON.parse(sessionStorage.getItem("token")).token
      ? JSON.parse(sessionStorage.getItem("token")).token
      : "";
  //console.log('d', d)
  const e = JSON.parse(sessionStorage.getItem("token"));
  const profileId = JSON.parse(sessionStorage.getItem("profileId"));
  return axiosInstance
    .get(`api/v1/upi/merchant/info/${profileId}`, {
      headers: { Authorization: `Bearer ${e}` },
    })
    .then((response) => {
      if (response) {
        const { data } = response;
        return data;
      }
      return false;
    })
    .catch((err) => {
      //console.log(err);
    });
}
